import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  filterByGenres,
  orderBy,
  getAllVideogames,
  getPageOne,
} from "../redux/actions";
import h from "../styles.module.css";
import Sidebar from "../components/navigation/navigation";
import Cards from "../components/cards/cards";
import Footer from "../components/footer/footer";
import ImageSlider from "../components/slider/slider";
import { SliderData } from "../components/slider/sliderData";

export default function Home() {
  const [toggle, setToggle] = useState(true);
  // me traigo los videogames
  const allVideogames = useSelector((state) => state.videogames);
  const dispatch = useDispatch();
  const [carga, setCarga] = useState(true);

  // logica de la paginacion, filtro por pagina y loading
  const [currentPage, setCurrentPage] = useState(1); //lo seteo en 1 porque siempre arranco por la primer pagina
  const gamesPerPage = 15; //cantidad de juegos que debe haber por pagina
  const indexOfLastGame = currentPage * gamesPerPage; // 1 * 15 = 15
  const indexOfFirstGame = indexOfLastGame - gamesPerPage; // 15 - 15 = 0
  const currentGame = allVideogames.slice(indexOfFirstGame, indexOfLastGame); //para dividir la cantidad de juegos por pagina
  const pagination = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    setCarga(true);
    dispatch(getPageOne(setCarga));
    dispatch(getAllVideogames());
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  function handleSort(e) {
    e.preventDefault();
    if (e.target.value === "") {
      dispatch(getAllVideogames());
    } else {
      dispatch(orderBy(e.target.value));
      setCurrentPage(1);
    }
  }

  function handleFilter(e) {
    e.preventDefault();
    if (e.target.value === "") {
      dispatch(getAllVideogames());
    } else {
      dispatch(filterByGenres(e.target.value));
      setCurrentPage(1);
    }
  }

  const wrapper = {
    position: "absolute",
    top: "0",
    left: "300px",
    width: "calc(100% - 300px)",
    height: "100%",
    paddingLeft: "2.5%",
    paddingRight: "2.5%",
    msOverflowStyle: "none",
    transition: "width 200ms, left 200ms, right 200ms",
  };

  const wrapperActive = {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    paddingLeft: "2.5%",
    paddingRight: "2.5%",
    msOverflowStyle: "none",
    transition: "width 200ms, left 200ms, right 200ms",
  };

  return (
    <div className={h.container}>
      <button className={h.burguer} onClick={() => setToggle(!toggle)}></button>
      <Sidebar
        toggle={toggle}
        handleFilter={handleFilter}
        handleSort={handleSort}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />

      <div style={toggle ? wrapper : wrapperActive}>
        <ImageSlider slides={SliderData} />
        <div className={h.main}>
          <span className={h.txtWhite}>
            <h2>Search results</h2>
          </span>
          <Cards
            currentGame={currentGame}
            carga={carga}
            currentPage={currentPage}
          />
          <Footer
            toggle={toggle}
            currentPage={currentPage}
            gamesPerPage={gamesPerPage}
            total={allVideogames.length}
            pagination={pagination}
          />
        </div>
      </div>
    </div>
  );
}
